export default __webpack_public_path__ + "static/media/lws.b586b927.svg";